import { Feature } from "ol";
import { Coordinate } from "ol/coordinate";
import { Point, Polygon } from "ol/geom";
import { Style, Fill, Stroke, Text } from "ol/style";

export const pivotDefaultStyle = (feature) => {
  const area = feature.get('area');
  return new Style({
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.25)',
    }),
    stroke: new Stroke({
      color: '#000',
      width: 2,
      lineDash: [2, 5],
    }),
    text: new Text({
      font: '12px Calibri,sans-serif',
      fill: new Fill({
        color: '#000',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
      text: area ? area.toFixed(2) + ' ha' : '',
    }),
  });
};

export function createSegmentPolygons(center: Coordinate, radius: number, numSegments: number) {
  const features = [] as Feature<Polygon>[];
  const degreesPerSegment = 360 / numSegments;
  const radiansPerSegment = (Math.PI / 180) * degreesPerSegment;

  for (let i = 0; i < numSegments; i++) {
    const segmentStartAngle = radiansPerSegment * i;
    const segmentEndAngle = segmentStartAngle + radiansPerSegment;

    const segmentPoints = [];
    segmentPoints.push(center);

    const steps = 20;
    for (let step = 0; step <= steps; step++) {
      const theta =
        segmentStartAngle +
        (segmentEndAngle - segmentStartAngle) * (step / steps);
      const x = center[0] + radius * Math.cos(theta);
      const y = center[1] + radius * Math.sin(theta);
      segmentPoints.push([x, y]);
    }

    segmentPoints.push(center);

    const polygon = new Polygon([segmentPoints]);
    const feature = new Feature(polygon);
    features.push(feature);
  }

  return features;
}